import { t } from 'i18next';

import { AlertCircleOutline, AlertTriangleOutline } from '@olist/design-system-icons';
import { tokens } from '@olist/design-system-tokens';

export const informativeCardData = [
  {
    message: t`Your address is compatible with our collection services!`,
    variation: 'success',
    messageColor: tokens.color.blue[800],
    icon: <AlertCircleOutline color={tokens.color.blue[800]} />,
  },
  {
    message: t`Oops! Your address is not compatible with our collection services.`,
    variation: 'alert',
    messageColor: tokens.color.red[800],
    icon: <AlertTriangleOutline color={tokens.color.red[800]} />,
  },
];
